// Internal modules
import { appStore, dispatchFormAction } from '@/store';
import { logger } from '@/lib';
import { upgradeGuestToMember } from './graphql';
import { displayFormErrors, filterFormState, validateForm } from './utils';
import {
  logFPTIWhenGuestOptionSubmitted,
  logFPTIWhenInterstitialClosed,
  logFPTIWhenUpgradeOptionSubmitted,
} from './fpti';

const signupClickHandler = () => {
  // need to strip away the form object and pass over only the
  // password and kyc field info itself
  const field = 'onboardOption';
  const payload = {
    displayError: false,
    error: '',
    errorCode: '',
    isDirty: true,
    isValid: true,
    value: 'signup',
  };

  dispatchFormAction({ field, payload });

  const { form: formState } = appStore.getState();
  const upgradeForm = filterFormState(formState);
  const { errorLogPayload, formErrors } = validateForm(upgradeForm);
  const fieldsWithErrors = Object.entries(formErrors);
  const { ui: uiActions } = appStore.getActions();

  // If form is not valid, add errors to state and display them
  if (fieldsWithErrors.length) {
    logger.fpti('wps_upgrade_invalid_form_submission', {
      state_name: 'Create_account',
      transition_name: 'process_invalid_create_account_submission',
    });
    displayFormErrors(fieldsWithErrors, formErrors);
    logger.info('wps_upgrade_invalid_form_submission', errorLogPayload);
    return logger.flush();
  }

  // Clear any existing page level error and show form submitting spinner
  uiActions.setPageLevelError('');
  uiActions.setPageWarningMessage('');
  uiActions.toggleIsFormSubmitting(true);
  upgradeGuestToMember();
  logFPTIWhenUpgradeOptionSubmitted();
};

const guestClickHandler = () => {
  const field = 'onboardOption';
  const payload = {
    displayError: false,
    error: '',
    errorCode: '',
    isDirty: true,
    isValid: true,
    value: 'guest',
  };
  const { ui: uiActions } = appStore.getActions();

  dispatchFormAction({ field, payload });
  logFPTIWhenGuestOptionSubmitted();
  uiActions.toggleIsUpgradeInterstitialOpen(false);
  logFPTIWhenInterstitialClosed();
  uiActions.toggleIsWPSDonePageOpen(true);
};

const upgradeSubmitHandler = e => {
  e.preventDefault();
  signupClickHandler();
};

export { guestClickHandler, signupClickHandler, upgradeSubmitHandler };
